<script lang="ts">
  import { Router } from 'svelte-routing';
  import App from './App.svelte';
  import { ToastContainer } from './lib/components/ui/index';
</script>

<Router>
  <App />
</Router>

<!-- Toast notifications (fixed, always on top); outside AppShell so logged-out views show them too -->
<ToastContainer />
